var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navbar-container"},[_c('img',{attrs:{"src":require('../assets/EENLogo.png')}}),_c('div',{staticClass:"navbar-container__horizontal-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }